import * as React from 'react'
import { Theme } from '@mui/material/styles'
import { FC, useCallback } from 'react'

import CardHeader, { cardHeaderClasses } from '@mui/material/CardHeader'
import FlipToFrontIcon from '@mui/icons-material/FlipToFront'
import IconButton from '@mui/material/IconButton'
import SettingsIcon from '@mui/icons-material/Settings'

const styles = {
  action: {
    marginTop: (theme: Theme) => theme.spacing(0),
    marginRight: (theme: Theme) => theme.spacing(0),
  },

  title: {
    fontFamily: 'Source Sans Pro Semibold',
  },
}

interface Props {
  action: () => void
  children?: JSX.Element
  className?: string
  color?: string
  showFront: boolean
  title: string
  testIdPrefix?: string
}

export const WidgetHeader: FC<Props> = (props) => {
  const {
    action,
    color,
    showFront,
    title,
    testIdPrefix = 'widget-header',
  } = props

  const handleAction = useCallback(() => {
    action()
  }, [action])

  const getBackgroundColor = () => {
    return { backgroundColor: color || '#e8f4fd' }
  }

  return (
    <CardHeader
      sx={{
        ...styles.action,
        [`& .${cardHeaderClasses.action}`]: { ...styles.action },
        [`& .${cardHeaderClasses.title}`]: { ...styles.title },
      }}
      style={getBackgroundColor()}
      title={title}
      titleTypographyProps={{ variant: 'body1' }}
      action={
        showFront ? (
          <IconButton
            data-test-id={`${testIdPrefix}-settings`}
            aria-label="Widget Settings"
            color="primary"
            onClick={handleAction}
            size="small"
            title="Widget Settings"
          >
            <SettingsIcon fontSize="small" />
          </IconButton>
        ) : (
          <IconButton
            data-test-id={`${testIdPrefix}-flip-to-front`}
            aria-label="Flip to Front"
            color="primary"
            onClick={handleAction}
            size="small"
            title="Flip to Front"
          >
            <FlipToFrontIcon fontSize="small" />
          </IconButton>
        )
      }
    />
  )
}

WidgetHeader.displayName = 'WidgetHeader'
